import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { formatDuration, formatRoundedDuration } from "@air/utilities";
import classNames from "classnames";
import { forwardRef, memo } from "react";
import { SpriteSheetThumbnail } from "~/components/PrivateAssetModal/PrivateChaptersPanel/components/SpriteSheetThumbnail";
export const ChapterCard = /*#__PURE__*/ memo(/*#__PURE__*/ forwardRef((param, ref)=>{
    let { chapter, index, isActive, onClick, clip } = param;
    return /*#__PURE__*/ _jsx("button", {
        ref: ref,
        type: "button",
        className: classNames("w-full rounded-8 py-4 text-left transition-colors", isActive ? "bg-grey-3" : "bg-grey-1 hover:bg-grey-3"),
        onClick: onClick,
        children: /*#__PURE__*/ _jsxs("div", {
            className: "flex flex-col",
            children: [
                /*#__PURE__*/ _jsxs("div", {
                    className: "flex justify-between",
                    children: [
                        /*#__PURE__*/ _jsxs("header", {
                            className: "mr-3 flex flex-col gap-1",
                            children: [
                                /*#__PURE__*/ _jsxs("h3", {
                                    className: "break-words text-12 font-semibold text-grey-11",
                                    children: [
                                        index + 1,
                                        ". ",
                                        chapter.title
                                    ]
                                }),
                                /*#__PURE__*/ _jsxs("p", {
                                    className: "text-12 text-grey-9 font-feature-tnum",
                                    children: [
                                        /*#__PURE__*/ _jsx("time", {
                                            dateTime: formatDuration(chapter.startTime),
                                            children: formatDuration(chapter.startTime)
                                        }),
                                        " –",
                                        " ",
                                        /*#__PURE__*/ _jsx("time", {
                                            dateTime: formatDuration(chapter.endTime),
                                            children: formatDuration(chapter.endTime)
                                        }),
                                        " \xb7",
                                        " ",
                                        /*#__PURE__*/ _jsx("time", {
                                            dateTime: formatDuration(chapter.endTime - chapter.startTime),
                                            children: formatRoundedDuration(chapter.endTime - chapter.startTime)
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsx(SpriteSheetThumbnail, {
                            clip: clip,
                            startTime: chapter.startTime,
                            endTime: chapter.endTime,
                            className: "h-12 w-20 shrink-0 rounded-6"
                        })
                    ]
                }),
                !!chapter.summary && /*#__PURE__*/ _jsx("p", {
                    className: "mt-2 text-12 text-grey-11",
                    children: chapter.summary
                })
            ]
        })
    });
}));
ChapterCard.displayName = "ChapterCard";
